<template>
    <v-app>
        <SyncIndicator />
        <FetchScoringButton />
        <!--
        <FeedbackForm />
        -->
        <div style="min-height: 100%; max-height: 100%;">
            <v-app-bar
                v-if="false"
                class="vp__top-nav --print--no-print"
                height="36"
                flat
                dense
                dark
                app
            >
                <v-app-bar-nav-icon
                    v-if="signedIn"
                    @click="navDrawer = !navDrawer"
                    x-small
                ></v-app-bar-nav-icon>
                <v-toolbar-items>
                    <v-btn
                        class="pr-0 vp__logo"
                        depressed
                        text
                        @click="goTo('App')"
                    >
                        <span class="mr-3 mr-md-6 "
                            >VIEWPOINT
                            <span class="vp__logo__360">360</span>
                        </span>
                    </v-btn>
                </v-toolbar-items>
                <div class="vp__title__decision text-truncate">
                    {{ toolbarTitle }}
                </div>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <SelectedInformationDebugTool />
                    <AccountMenu :signed-in="signedIn" />
                </v-toolbar-items>
            </v-app-bar>
            <div 
                v-if="!embedApp" 
                style="position: absolute; top: 0; z-index: 6;"
                :class="menuLeftOffset ? 'vp__accountMenu-wrapper' : 'vp__accountMenu-wrapper--sm'"
                >
                <AccountMenu :signed-in="signedIn" class="vp__top-accountmenu" />
            </div>
            <router-view
                :nav-drawer-prop="navDrawer"
                @nav-drawer-changed="navDrawerChanged"
            />
        </div>
    </v-app>
</template>

<script>
import { Auth } from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';
import Navigation from '@/store/modules/Navigation';
import AccountMenu from '@/components/account/AccountMenu.vue';
import Users from '@/store/modules/Users';
import SyncIndicator from '@/components/workspace-notifications/SyncIndicator';
import DecisionShareDialog from '@/components/decisions/DecisionManageUsersDialog.vue';
import RefreshScoringButton from '@/components/scoring-input/RefreshScoringButton';
import FeedbackForm from '@/components/forms/FeedbackForm';
import SelectedInformationDebugTool from '@/components/debug/SelectedInformationDebugTool';
import { Urls } from "@/Urls";

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users);
const navigationModule = getModule(Navigation);
const URLS = Urls;

export default {
    name: 'app',
    components: {
        SelectedInformationDebugTool,
        FeedbackForm,
        FetchScoringButton: RefreshScoringButton,
        SyncIndicator,
        AccountMenu,
        DecisionShareDialog,
    },

    data() {
        return {
            signedIn: false,
            navDrawer: true,
            previousDecisionTitle: '',
            decisionTitle: '',
        //    URLS: Urls,
            menuLeftOffset: true,
            embedApp: false,
        };
    },

    async beforeCreate() {
        console.log('Testing Concord Auto Login');

        let loggedIn = false;
        try {
            Auth.currentAuthenticatedUser()
            .then((user) => {
                console.log('Already logged in:');
                console.log(user);
                loggedIn = true;
                usersModule.fetchCurrentUserData();
                decisionsModule.fetchDecisions();
            })
            .catch((err) => {
                // console.log(err);
                console.error("User Authentication Error");
            });
        } catch(error) {
            console.error(error);
        }

        if ((window.location.hostname === 'concord.viewpoint-ai.com') && !loggedIn) {
            try {
                const user = await Auth.signIn('viewpoint-admin@viewpoint.ai', 'Viewpoint-admin1!');
                console.log('user');
                console.log(user);
            } catch (error) {
                console.error(error);
            }
        }

        if ((window.location.hostname === 'localhost') && !loggedIn) {
            try {
                // const user = await Auth.signIn('ddifelice@viewpoint.ai', 'Qw3rty9257!!!');
                const user = await Auth.signIn('viewpoint-guest@viewpoint.ai', 'Summertime1!');
                console.log('user');
                console.log(user);
            } catch (error) {
                console.error(error);
            }
            decisionsModule.sendChoiceSubmissionEmail({userId: 'us-west-2:bab5c1fd-adce-41e8-a5c4-7efa4d316b4d', email: 'dion.difelice@gmail.com', choiceId: 'dddddddd-665c-4e35-bbb1-b09da6bcf9bf', link: 'https://google.com', adminEmail: 'ddifelice@viewpoint.ai', userDetails: 'BLAH', userDetailsHtml: 'BLAH', linkText: 'LINK TEXT' });
        }

        if (this.$router.currentRoute.path !== '/input/choice') {
            Hub.listen(
                'auth',
                (data) => {
                    if (data.payload.event === 'signIn') {
                        this.signedIn = true;
                        navigationModule.setAnonUserId('');
                        if (this.$router.currentRoute.path !== '/') {
                            
                            const fullPath = this.$route.fullPath;
                            const path = fullPath.substring(
                                fullPath.indexOf('?')
                            );
                            let redirectAfterAuthPath = getModule(Navigation)
                                .redirectAfterAuthPath;

                            if (
                                redirectAfterAuthPath &&
                                fullPath !== redirectAfterAuthPath
                            ) {
                                getModule(
                                    Navigation
                                ).changeRedirectAfterAuthPath(null);
                                this.$router.push(redirectAfterAuthPath);
                            } else if (fullPath === path) {
                                this.$router.push('/');
                            } else {
                                if (path.indexOf('shareCode') >= 0) {
                                    this.$router.push('/share' + path);
                                } else if(!fullPath.includes('app/share')) {
                                    this.$router.push('/' + path);
                                }
                            }
                        }
                    } else if (data.payload.event === 'signOut') {
                        this.signedIn = false;
                        if (
                            this.$router.currentRoute.path !== '/accounts/login'
                        ) {
                            window.location.href = Urls.VIEWPOINT_HOSTED;
                        }
                    }
                },
                'authListener'
            );
        }        

        Auth.currentAuthenticatedUser()
            .then((user) => {
                // Auth.currentUserCredentials().then(re => console.log(re))
                this.signedIn = true;
                usersModule.fetchCurrentUserData();
            })
            .catch(() => {
                this.signedIn = false;
            });
    },

    mounted() {
        document.title = 'Viewpoint 360 - AI-Enhanced Team Decisions';
        this.checkMenuLeftPath(this.$router.currentRoute.path)
        this.checkEmbedPath(this.$router.currentRoute.path)
        // log out from main tool if user loggin out from Drupal
        window.addEventListener("message", function(e){
            if (e.data && e.origin == 'https://viewpoint-ai.com') {
                if(e.data == 'drupal-logout') {
                    Auth.signOut();
                }
            }
        });
        this.embedApp = this.$route.path == URLS.APP_EMBED || this.$route.path == URLS.APP_SHARE;
    },

    computed: {

        toolbarTitle() {
            document.title = 'Viewpoint 360 - AI-Enhanced Team Decisions';
            return '';
        },
        // decision title
        selectedDecision: {
            // getter
            get: () => {
                // console.log(decisionsModule.selectedDecision);
                return decisionsModule.selectedDecision;
            },
        },
        // viewpoint title
        activeViewpointId: {
            get: () => {
                return viewpointsModule.activeViewpointId;
            },
        },

        currentUrl() {
            return this.$router.currentRoute.path.substring(0,6);
        }
    },

    watch: {
        // decision - change title
        selectedDecision: {
            deep: false,
            handler() {
                // console.log(this.selectedDecision);
                if (this.selectedDecision) {
                    // console.log(this.activeViewpoint);
                    // if (this.activeViewpoint) {
                    if (this.selectedDecision.hasOwnProperty('name'))
                        document.title = this.selectedDecision?.name;
                    else {
                        document.title =
                            'Viewpoint 360 - AI-Enhanced Team Decisions';
                    }
                } else {
                    document.title =
                        'Viewpoint 360 - AI-Enhanced Team Decisions';
                }
            },
        },
        // viewpoint - change title
        activeViewpointId: {
            deep: false,
            handler() {
                if (this.activeViewpointId && this.selectedDecision && viewpointsModule.decisionViewpointsMap && viewpointsModule.decisionViewpointsMap.hasOwnProperty(this.activeViewpointId)) {
                    var viewpoint =
                        viewpointsModule.decisionViewpointsMap[
                            this.activeViewpointId
                        ];
                    if (
                        viewpoint &&
                        viewpoint.hasOwnProperty('name') &&
                        this.selectedDecision.hasOwnProperty('name')
                    ) {
                        document.title = viewpoint.name + ' | ' + this.selectedDecision.name;
                    }
                } else {
                    document.title = this.selectedDecision ? this.selectedDecision.name : 'Viewpoint 360 - AI-Enhanced Team Decisions';
                }
                // console.log(this.activeViewpoint);
            },
        },

        '$route.path': {
            deep: true,
            immediate: true,
            handler: function(newVal) {
                this.checkMenuLeftPath();
                this.checkEmbedPath();
            }
        },
    },

    methods: {
        goTo(name) {
            if (this.$router.currentRoute.name !== name) {
                this.$router.push({ name: name });
            }
        },
        navDrawerChanged(newVal) {
            this.navDrawer = newVal;
        },
        checkMenuLeftPath() {
            let path = this.$route.path;
            const regEx = new RegExp('^\/pricing/plans|^\/accounts/*');
            if ( regEx.test(path) ) {
                this.menuLeftOffset = false;
            }
            else {
                this.menuLeftOffset = true;
            }
        },
        checkEmbedPath() {
            let path = this.$route.path;
            this.embedApp = this.$route.path == URLS.APP_EMBED || this.$route.path == URLS.APP_SHARE;
        }
    },
};
</script>

<style>
@import 'styles/viewpoint.css';
@import 'styles/viewpoint_print.css' print;
@import 'https://fonts.googleapis.com/css?family=Nunito:200,300,400,600,700,800,900';
@import 'https://fonts.googleapis.com/css?family=Montserrat:100,200,300,400,500,600,700,800,900';
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css';

/** PRINT CSS **/

@media print {
    body {
        color: #000 !important;
        background: #fff !important;
    }

    #app {
        background-color: #fff !important;
    }
}

@media print and (color) {
    * {
        -webkit-print-color-adjust: exact;
    }
}

/** CSS **/

#app {
    font-family: 'Nunito', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f3f3f3;
    color: var(--blue-30);
}

.container--fluid {
    max-width: 100% !important;
}

.v-navigation-drawer.vp__nav-drawer .v-navigation-drawer__content {
    background: linear-gradient(290deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0));
    background: #fff !important;
}

.v-navigation-drawer.vp__nav-drawer .v-list {
    background: transparent !important;
}

.vp__top-nav .v-toolbar__items {
    position: relative;
}

.vp__top-nav,
.vp__top-nav .v-toolbar__content {
    color: #fff !important;
    font-family: 'Montserrat' !important;
    /* background: #428dd8 !important; */
    background: #1a5276 !important;
    background: var(--vp--primary) !important;
    border-color: var(--vp--primary) !important;
    text-rendering: optimizeLegibility;
}

.vp__top-nav,
.vp__top-nav .v-toolbar__content,
.vp__top-nav button.vp__main-nav__item span.v-btn__content {
    height: 36px !important;
    min-height: 36px !important;
    max-height: 36px !important;
}

.vp__top-nav button.vp__main-nav__item span.v-btn__content {
    display: block;
    padding: 4px 0 0 0;
    border-top: 4px solid transparent;
}

.vp__top-nav button.vp__main-nav__item.--vp--active span.v-btn__content {
    border-top: 4px solid white;
}

.vp__top-nav button {
    font-weight: 700 !important;
    letter-spacing: 0.25px !important;
    opacity: 0.85 !important;
}

.vp__top-nav button:hover {
    opacity: 1 !important;
}

.vp__top-nav button.v-app-bar__nav-icon {
    height: 36px !important;
    width: 36px !important;
}

.vp__top-nav button.vp__logo {
    font-weight: 600 !important;
    font-size: 15.5px !important;
    opacity: 1 !important;
    letter-spacing: -0.025px;
}

.vp__top-nav button span.vp__logo__360 {
    font-size: 16px !important;
    font-weight: 900 !important;
    padding-left: 4px;
}

button.vp--secondary {
    color: #42d87e;
}

.vp__title__decision {
    position: absolute;
    left: 240px;
    text-align: center;
    font-weight: 700;
    letter-spacing: 0.025rem;
    min-width: calc(100% - 480px);
    max-width: calc(100% - 480px);
}

.rotate {
    animation: rotation 2s infinite linear;
}

.vp__accountMenu-wrapper {
    left: 28px;
}

.vp__accountMenu-wrapper--sm {
    background: var(--vp--primary);
    height: 100%;
    width: 40px;
}

@keyframes rotation {
    from {
        transform: rotate(359deg);
    }
    to {
        transform: rotate(0deg);
    }
}
</style>
